import { StyleTheme, Theme } from '@b2b/features/misc/style-theme/core/style-theme.model';

const light: StyleTheme = {
  name: 'sc-theme',
  core: {
    common: {
      colors: {
        text: '#333',
        background: '#F7F7F7',
      },
    },
    simpleCard: {
      colors: {
        background: '#FFF',
      },
    },
  },
  theme: {
    colors: {
      primary: '#f07f3c',
      secondary: '#1c2445',

      success: '#518252',
      warning: '#ea960e',
      danger: '#c20707',
      info: '#0dcaf0',
    },
  },
};

const dark: StyleTheme = {
  ...light,
  name: 'sc-theme-dark',
  core: {
    common: {
      colors: {
        text: '#fff',
        background: '#111',
      },
    },
    simpleCard: {
      colors: {
        background: '#333',
      },
    },
  },
};

export const NDBSTheme: Theme = { light, dark };
